import path from "path";

// routes/routeConfig.js
export const ROUTES = {
  PUBLIC: {
    LANDING: { 
      path: '/', 
      layout: null,  // No layout for landing page - it has its own navigation
      redirectIfAuthenticated: false  // Allow authenticated users to see landing page
    },
    LOGIN: { 
      path: '/auth/login',
      layout: 'AuthLayout',
      redirectIfAuthenticated: true 
    },
    REGISTER: { 
      path: '/auth/register',
      layout: 'AuthLayout',
      redirectIfAuthenticated: true 
    },
    FORGOT_PASSWORD: { 
      path: '/auth/forgot-password', 
      layout: 'AuthLayout' 
    },
    UNAUTHORIZED: {
      path: '/unauthorized',
      layout: null
    },
    PRIVACY_POLICY: {
      path: '/privacy-policy',
      layout: null,
      redirectIfAuthenticated: false
    },
    TERMS_AND_CONDITIONS: {
      path: '/terms-and-conditions',
      layout: null,
      redirectIfAuthenticated: false
    },
    CONTACT_US: {
      path: '/contact-us',
      layout: null,
      redirectIfAuthenticated: false
    },
  },

  PROTECTED: {
    // Admin routes
    ADMIN_DASHBOARD: { 
      path: '/admin/analytics', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin'] 
    },
    ADMIN_COLLEGES: { 
      path: '/admin/college-management', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin'] 
    },
    ADMIN_CREATE_COLLEGE: { 
      path: '/admin/college-management/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_SME: { 
      path: '/admin/sme-approval', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin'] 
    },
    ADMIN_CERTIFICATES: { 
      path: '/admin/certificates', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin'] 
    },
    ADMIN_ANALYTICS: { 
      path: '/admin/analytics', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin'] 
    },
    ADMIN_SME_MANAGEMENT: {
      path: '/admin/sme-management',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CREATE_SME: {
      path: '/admin/sme-management/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CONFIGURATION: {
      path: '/admin/admin-configuration',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_COURSE_CATEGORIES: {
      path: '/admin/course-management/categories',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CREATE_COURSE_CATEGORY: {
      path: '/admin/course-management/categories/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_COURSE_MANAGEMENT: {
      path: '/admin/course-management',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_COURSE_CONTENT: {
      path: '/admin/course-management/course/[courseId]/content',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_COURSE_CONTENT_CREATE: {
      path: '/admin/course-management/content/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_COURSE_CONTENT_EDIT: {
      path: '/admin/course-management/content/edit/[contentId]',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CREATE_COURSE: {
      path: '/admin/course-management/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_EDIT_COURSE: {
      path: '/admin/course-management/edit/[id]',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
ADMIN_EXAM_MANAGEMENT: {
      path: '/admin/exams',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CREATE_EXAM: {
      path: '/admin/exams/create',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_EDIT_EXAM: {
      path: '/admin/exams/edit/[examId]',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
   ADMIN_EXAM_ATTEMPTS: {
      path: '/admin/exams/[examId]/attempts',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
      ADMIN_EXAM_LIVE: {
      path: '/admin/exams/[examId]/analytics',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CHATBOT_SETTINGS: {
      path: '/admin/chatbot-settings',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_STUDENT_CERTIFICATES: {
      path: '/admin/certificates/students',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_STUDENT_CERTIFICATE_DETAIL: {
      path: '/admin/certificates/students/[studentId]',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_CUSTOM_CERTIFICATE: {
      path: '/admin/custom-certificates',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },
    ADMIN_PROGRESS_TRACKING: {
      path: '/admin/progress-tracking',
      layout: 'DashboardLayout',
      allowedRoles: ['admin']
    },

ADMIN_EXAM_INFO:{
path: '/admin/exams/[examId]',
layout: 'DashboardLayout',
allowedRoles: ['admin']
},

ADMIN_QUESTION_BANK: {
  path: '/admin/question-bank',
  layout: 'DashboardLayout',
  allowedRoles: ['admin']
},

ADMIN_SEMESTER_PROMOTION: {
  path: '/admin/semester-promotion',
  layout: 'DashboardLayout',
  allowedRoles: ['admin']
},

    // Student routes  
    STUDENT_DASHBOARD: { 
      path: '/student/dashboard', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
    STUDENT_NOTIFICATIONS: {
      path: '/student/notifications',
      layout: 'DashboardLayout',
      allowedRoles: ['student']
    },
    STUDENT_COURSES: { 
      path: '/student/courses/available_courses', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },

      STUDENT_COURSE_DETAIL: { 
      path: '/student/courses/[courseId]', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
    STUDENT_ASSESSMENTS: { 
      path: '/student/assessments', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
    STUDENT_EXAMS: { 
      path: '/student/exam', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
  
    STUDENT_RESULTS: { 
      path: '/student/results', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
     STUDENT_EXAM_RESULTS: { 
      path: '/student/exam/results', 
      layout: 'DashboardLayout',
      allowedRoles: ['student'] 
    },
    STUDENT_PROFILE:{
      path: '/student/profile',
      layout: 'DashboardLayout',
      allowedRoles: ['student']
    },
   
    // SME routes
    SME_DASHBOARD: { 
      path: '/sme/dashboard', 
      layout: 'DashboardLayout',
      allowedRoles: ['sme'] 
    },
    SME_CONTENT: { 
      path: '/sme/content-upload', 
      layout: 'DashboardLayout',
      allowedRoles: ['sme'] 
    },
    SME_QUIZ: { 
      path: '/sme/quiz-creation', 
      layout: 'DashboardLayout',
      allowedRoles: ['sme'] 
    },
    SME_NOTIFICATION: { 
      path: '/sme/notifications', 
      layout: 'DashboardLayout',
      allowedRoles: ['sme'] 
    },
    
    // College routes
    COLLEGE_DASHBOARD: { 
      path: '/college/dashboard', 
      layout: 'DashboardLayout',
      allowedRoles: ['college'] 
    },
    COLLEGE_STUDENTS: { 
      path: '/college/student-management', 
      layout: 'DashboardLayout',
      allowedRoles: ['college','admin'] 
    },
    COLLEGE_COURSES:{
     path: '/college/courses',
      layout: 'DashboardLayout',
      allowedRoles: ['college']
    },
    COLLEGE_PROGRESS_TRACKING: {
      path: '/college/progress-tracking',
      layout: 'DashboardLayout',
      allowedRoles: ['college']
    },
    COLLEGE_CERTIFICATES: {
      path: '/college/certificate-publishing',
      layout: 'DashboardLayout',
      allowedRoles: ['college']
    },
    // Common routes (accessible by all authenticated users)
    PROFILE: { 
      path: '/profile', 
      layout: 'DashboardLayout',
      allowedRoles: ['admin', 'student', 'sme', 'college'] 
    }
  }
};

// Helper functions
export const getRouteConfig = (path) => {
  const allRoutes = { ...ROUTES.PUBLIC, ...ROUTES.PROTECTED };
  const config = Object.values(allRoutes).find(route => route.path === path);
  console.log('🛣️ Route config for', path, ':', config);
  return config;
};

export const isPublicRoute = (path) => {
  const isPublic = Object.values(ROUTES.PUBLIC).some(route => route.path === path);
  console.log('📖 Is public route', path, ':', isPublic);
  return isPublic;
};

// ✅ Updated: Direct role-based redirect (no /dashboard)
export const getRoleBasedRedirect = (role) => {
  const roleRedirects = {
    'admin': '/admin/analytics',
    'student': '/student/courses/available_courses',
    'sme': '/sme/dashboard',
    'college': '/college/courses'
  };
  const redirectPath = roleRedirects[role?.toLowerCase()] || '/auth/login';
  console.log('🎯 Role redirect for', role, ':', redirectPath);
  return redirectPath;
};
